import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {ListingPage} from "../../utils/types/listing_page";
import {filterPreset_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template';
import {multipleSelector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';
import {filterTag_template} from './filterTag_template';

declare var ko: any;


export class listingPagesList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected filterPreset: filterPreset_template;
    protected permalinkConfigFilter: multipleSelector_template;
    protected pageTypeFilter: multipleSelector_template;
    protected hasPinnedArticleFilter: multipleSelector_template;
    protected hasPinnedHubPageFilter: multipleSelector_template;
    protected hasSubContentArticleFilter: multipleSelector_template;
    protected pinnedTagFilter: filterTag_template;
    protected articleCharacteristicsFilter: multipleSelector_template;
    protected contentTypesFilter: multipleSelector_template;
    protected categoriesFilter: multipleSelector_template;

    public static PERMALINK_CONFIGS = [
        {id: 1, name: "Has Permalink"},
        {id: 2, name: "No Permalink"},
        {id: 3, name: "Resolves To Different Hub"}
    ];
    public static PAGE_TYPES = [
        {id: 1, name: "List of articles", value: "articles"},
        {id: 2, name: "List of tags", value: "tags"},
        {id: 3, name: "Video Homepage", value: "homepage_video"},
        {id: 4, name: "Thread Homepage", value: "homepage_thread"},
        {id: 5, name: "Database HUB", value: "tagHub"},
        {id: 6, name: "Channel", value: "channel"},
        {id: 7, name: "Deals", value: "deals"},
        {id: 8, name: "Theme Page", value: "theme_page"},
        {id: 9, name: "TV Schedule Homepage", value: "homepage_tv_schedule"},
        {id: 10, name: "Sub-Content Hub", value: "subContentHub"}
    ];

    public static ARTICLE_CHARACTERISTICS = [
        {id: 1, name: "Featured Emaki Video", value: "featuredEmaki"},
        {id: 2, name: "Featured Youtube Embed", value: "featuredYoutube"}
    ];

    public static YES_OR_NO = [
        {id: 1, name: "Yes"},
        {id: 0, name: "No"}
    ];

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header filter-preset w-justify ">${this.filterPreset.getHtmlBuild()}</div>
            <div class="sub-header w-justify">
                <div class="w-left">
                 ${this.permalinkConfigFilter.getHtmlBuild()}
                 ${this.pageTypeFilter.getHtmlBuild()}
                 ${this.hasPinnedArticleFilter.getHtmlBuild()}
                 ${this.hasPinnedHubPageFilter.getHtmlBuild()}
                 ${this.hasSubContentArticleFilter.getHtmlBuild()}
                 ${this.articleCharacteristicsFilter.getHtmlBuild()}
                 ${this.contentTypesFilter.getHtmlBuild()}
                 ${this.categoriesFilter.getHtmlBuild()}
                 ${this.pinnedTagFilter.getHtmlBuild()}
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-permalink-configs"></div>
                   <div id="selected-page-types"></div>
                   <div id="selected-has-pinned-articles"></div>
                   <div id="selected-has-pinned-hub-pages"></div>
                   <div id="selected-has-sub-content-articles"></div>
                   <div id="selected-article-characteristics"></div>
                   <div id="selected-pinned-tags"></div>
                </div>
            </div>

            <div class="list-header w-justify">
               <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add Hub Page</button>
                    <button data-bind="visible: canDeleteListingPages, event: {click: onClickDeleteWithCsv}" class="btn secondary icon i-delete" type="button">Trash Hubs</button>
                    <input data-bind="event: {change: onCsvDeleteFileSelected}" type="file" accept=".csv,text/csv" class="is-hidden" id="listing-pages-delete-csv-file">
               </div>
               <div class="w-center">${this.filter.getHtmlBuild()}</div>
               <div class="w-right">${this.pagination.getHtmlBuild()}</div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Identifier</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'permalink') }, css: { 'list-sort-desc': orderByAndDirection()=='permalink_DESC', 'list-sort-asc': orderByAndDirection()=='permalink_ASC' }">Permalink</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'description') }, css: { 'list-sort-desc': orderByAndDirection()=='description_DESC', 'list-sort-asc': orderByAndDirection()=='description_ASC' }">Description</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Creation Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Update Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                            <th><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: listingPages">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex">
                                        <span data-bind="text: name"></span>
                                        <button type="button" data-bind="event: { click: $parent.viewOnWebsite }" class="btn icon border only-icon i-link"></button>
                                    </div>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: permalink" ></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: type"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: description"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: articleCount"></span></a></td>
                            <td>
                                <button class="btn border highlight only-icon icon i-delete" data-bind="visible: !isNotDeletable, event: { click: $parent.onClickDelete }" type="button" ></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('listingPages');

        this.permalinkConfigFilter = new multipleSelector_template("permalinkConfigFilter", this.getTemplateViewModel(), this.caller);
        this.permalinkConfigFilter.setLabel('Permalink Configurations');
        this.permalinkConfigFilter.setFilterContainerClass('margin-neg');
        this.permalinkConfigFilter.setTagContainerId('selected-permalink-configs');
        this.permalinkConfigFilter.setTagContainerCaption('Selected Permalink Configurations:');
        this.permalinkConfigFilter.setItems(listingPagesList_template.PERMALINK_CONFIGS);

        this.pageTypeFilter = new multipleSelector_template("pageTypeFilter", this.getTemplateViewModel(), this.caller);
        this.pageTypeFilter.setLabel('Page Types');
        this.pageTypeFilter.setFilterContainerClass('margin-neg');
        this.pageTypeFilter.setTagContainerId('selected-page-types');
        this.pageTypeFilter.setTagContainerCaption('Selected Page Types:');
        this.pageTypeFilter.setItems(listingPagesList_template.PAGE_TYPES);

        this.hasPinnedArticleFilter = new multipleSelector_template("hasPinnedArticleFilter", this.getTemplateViewModel(), this.caller);
        this.hasPinnedArticleFilter.setLabel('Has Pinned Article');
        this.hasPinnedArticleFilter.setFilterContainerClass('margin-neg');
        this.hasPinnedArticleFilter.setTagContainerId('selected-has-pinned-articles');
        this.hasPinnedArticleFilter.setTagContainerCaption('Selected Has Pinned Articles:');
        this.hasPinnedArticleFilter.setItems(listingPagesList_template.YES_OR_NO);

        this.hasPinnedHubPageFilter = new multipleSelector_template("hasPinnedHubPageFilter", this.getTemplateViewModel(), this.caller);
        this.hasPinnedHubPageFilter.setLabel('Has Pinned Hub Page');
        this.hasPinnedHubPageFilter.setFilterContainerClass('margin-neg');
        this.hasPinnedHubPageFilter.setTagContainerId('selected-has-pinned-hub-pages');
        this.hasPinnedHubPageFilter.setTagContainerCaption('Has Pinned Hub Pages:');
        this.hasPinnedHubPageFilter.setItems(listingPagesList_template.YES_OR_NO);

        this.hasSubContentArticleFilter = new multipleSelector_template("hasSubContentArticleFilter", this.getTemplateViewModel(), this.caller);
        this.hasSubContentArticleFilter.setLabel('Has Sub Content Article');
        this.hasSubContentArticleFilter.setFilterContainerClass('margin-neg');
        this.hasSubContentArticleFilter.setTagContainerId('selected-has-sub-content-articles');
        this.hasSubContentArticleFilter.setTagContainerCaption('Has Sub Content Articles:');
        this.hasSubContentArticleFilter.setItems(listingPagesList_template.YES_OR_NO);

        this.pinnedTagFilter = new filterTag_template("pinnedTagFilter", this.getTemplateViewModel(), this.caller);
        this.pinnedTagFilter.setPlaceholderText('Pinned Tag');
        this.pinnedTagFilter.asMultipleSelectionMode();
        this.pinnedTagFilter.setTagContainerId('selected-pinned-tags');
        this.pinnedTagFilter.setTagContainerCaption('Selected Pinned Tags:');

        this.articleCharacteristicsFilter = new multipleSelector_template("articleCharacteristicsFilter", this.getTemplateViewModel(), this.caller);
        this.articleCharacteristicsFilter.setLabel('Article Characteristics');
        this.articleCharacteristicsFilter.setFilterContainerClass('margin-neg');
        this.articleCharacteristicsFilter.setTagContainerId('selected-article-characteristics');
        this.articleCharacteristicsFilter.setTagContainerCaption('Selected Article Characteristics:');
        this.articleCharacteristicsFilter.setItems(listingPagesList_template.ARTICLE_CHARACTERISTICS);

        this.contentTypesFilter = new multipleSelector_template("contentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypesFilter.setLabel("Content Types");
        this.contentTypesFilter.setFilterContainerClass('margin-neg');
        this.contentTypesFilter.setTagContainerId('selected-content-types');
        this.contentTypesFilter.setTagContainerCaption('Selected Content Types:');

        this.categoriesFilter = new multipleSelector_template("categoriesFilter", this.getTemplateViewModel(), this.caller);
        this.categoriesFilter.setLabel("Categories");
        this.categoriesFilter.setFilterContainerClass('margin-neg');
        this.categoriesFilter.setTagContainerId('selected-categories');
        this.categoriesFilter.setTagContainerCaption('Selected Categories:');


    }

    protected getTemplateName(): string {
        return "listingPagesList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        const self = this;
        return {
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            listingPages: ko.observableArray([]),
            isAddButtonShown: ko.observable(false),
            canDeleteListingPages: ko.observable(false),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewListingPage: (data, event) => {
                self.viewListingPage(data.id, event);
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
            onClickDelete: (value, data, event) => {
                self.onClickDelete(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd();
            },
            onClickDeleteWithCsv: (data, event) => {
                self.onClickDeleteWithCsv(event);
            },
            onCsvDeleteFileSelected: (data, event) => {
                self.onCsvDeleteFileSelected(event);
            }
        };
    }

    private viewOnWebsite(value) {
        // prevent click to trigger onClick bindings of outer elements that click also targets
        window.event.stopPropagation();

        this.caller.viewOnWebsite(value.permalink);
    }

    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'listingPages',
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                permalinkConfig: this.getTemplateViewModel().permalinkConfigFilter.selectedItems,
                pageType: this.getTemplateViewModel().pageTypeFilter.selectedItems,
                hasPinnedArticle: this.getTemplateViewModel().hasPinnedArticleFilter.selectedItems,
                hasPinnedHubPage: this.getTemplateViewModel().hasPinnedHubPageFilter.selectedItems,
                hasSubContentArticle: this.getTemplateViewModel().hasSubContentArticleFilter.selectedItems,
                tags: this.pinnedTagFilter.getTagsForRequest(),
                articleCharacteristics: this.getTemplateViewModel().articleCharacteristicsFilter.selectedItems,
                contentTypes: this.getTemplateViewModel().contentTypesFilter.selectedItems,
                categories: this.getTemplateViewModel().categoriesFilter.selectedItems
            }
        };
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        // if the column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() === "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            // default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listingPagesListReorder();
    }

    public onClickAdd() {

        this.caller.add();
    }

    public onClickDeleteWithCsv(event): void {
        event.stopPropagation();

        const csvInput = document.getElementById('listing-pages-delete-csv-file') as HTMLInputElement;
        csvInput.click();
    }

    public onCsvDeleteFileSelected(event): void {
        event.stopPropagation();

        const csvInput = event.target as HTMLInputElement;
        const csvFile = csvInput.files && csvInput.files.length > 0 ? csvInput.files[0] : null;
        if (!csvFile) {
            return;
        }

        const deleteConfirmation: boolean = confirm("You're about to delete listing pages in bulk. Are you sure?");
        if (deleteConfirmation === true) {
            this.caller.bulkDelete(csvFile);
        } else {
            csvInput.value = '';
        }
    }

    protected viewListingPage(data, event): any {
        this.caller.viewListingPage(data);
    }

    public onClickDelete(listingPage: ListingPage): void {
        window.event.stopPropagation();

        if (listingPage.isNotDeletable) {
            return;
        }

        const deleteConfirmation: boolean = confirm('Are you sure you want to delete (' + listingPage.name + ') Hub Page.  Do you want to proceed?');
        if (deleteConfirmation === true) {
            this.caller.delete(listingPage.id);
        }
    }

    public setContentTypesFilterItems(items: string[]): void {
        this.contentTypesFilter.setItems(items);
    }

    public setCategoriesFilterItems(items: string[]): void {
        this.categoriesFilter.setItems(items);
    }


    public setListingPages(listingPages: ListingPage[], brandId): void {

        listingPages.forEach((lp) => lp['emakiView'] = '/brand/' + brandId + '/config/listing-pages/view/' + lp.id);

        this.getTemplateViewModel().listingPages(listingPages);
    }


    public setAddButtonShown(isAddButtonShown: boolean): void {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setCanDeleteListingPages(canDeleteListingPages: boolean): void {
        this.getTemplateViewModel().canDeleteListingPages(canDeleteListingPages);
    }

    public setResultInfo(nbResults, nbPages, execTime): void {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setItemCount(count: number): void {
        this.pagination.getTemplateViewModel().itemCount(count);
    }

    public setPageNumber(page: number): void {
        this.pagination.getTemplateViewModel().pageNumber(page);
    }

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public setFilterSelectedItems(objFilter, urlParams) {

        let splitString = [];

        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams === "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            const arrayParam = [];
            const idTagArray = [];
            splitString.forEach((id) => {

                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({id});
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            this.setFilterSelectedItems(this.permalinkConfigFilter, urlParams.permalinkConfig);
            this.setFilterSelectedItems(this.pageTypeFilter, urlParams.pageType);
            this.setFilterSelectedItems(this.hasPinnedArticleFilter, urlParams.hasPinnedArticle);
            this.setFilterSelectedItems(this.hasPinnedHubPageFilter, urlParams.hasPinnedHubPage);
            this.setFilterSelectedItems(this.hasSubContentArticleFilter, urlParams.hasSubContentArticle);
            this.setFilterSelectedItems(this.articleCharacteristicsFilter, urlParams.articleCharacteristics);
            this.setFilterSelectedItems(this.contentTypesFilter, urlParams.contentTypes);
            this.setFilterSelectedItems(this.categoriesFilter, urlParams.categories);

            let keywords = urlParams.keywords;
            if (keywords) {
                keywords = keywords.replaceAll("+", " ");
            }
            this.getTemplateViewModel().filter.filterKeyword(keywords);

            if (urlParams.tags) {
                this.pinnedTagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
            } else {
                this.pinnedTagFilter.resetTagContainer();
            }
        }

    }

    public setDefaultFilters() {
        // No default filters
    }

    private setTagPreset(idTag: number, tag: string): void {

        this.pinnedTagFilter.getTemplateViewModel().idTag(idTag);
        this.pinnedTagFilter.getTemplateViewModel().tag(tag);
        this.pinnedTagFilter.toggleCloseButton();
    }

    protected setTagFilter(tags) {

        this.pinnedTagFilter.setTags(tags);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/listingPagesList_template.ts